import { Action } from '@ngrx/store';

import { Tenant } from './tenant';

export enum TenantActionTypes {
  INITIALISE = '[Tenant] Initialise',
}

export class InitialiseWithTenantAction implements Action {
  readonly type = TenantActionTypes.INITIALISE;

  constructor(public payload: Tenant) {}
}

export type TenantActions = InitialiseWithTenantAction;
